import { queryTextMarkups } from './TextMarkupGLLayer'

// Whether anything from these layers is drawn at a canvas point: style layers through mapbox's
// hit test, text layers through ours.
export function isPointOverLayers(
  map: mapboxgl.Map,
  point: { x: number; y: number },
  layerIds: string[] = [],
  textLayerIds: string[] = [],
): boolean {
  const layers = layerIds.filter(id => map.getLayer(id))
  return (
    (layers.length > 0 &&
      map.queryRenderedFeatures([point.x, point.y], { layers }).length > 0) ||
    (textLayerIds.length > 0 &&
      queryTextMarkups(map, point, textLayerIds).length > 0)
  )
}
